import { useEffect, useState } from 'react';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { ACTION_MODE } from '../ListTaxonomies';
import { TaxonomyNode } from './TaxonomyNode';
import { TreeItem } from './TreeItem';

interface TaxonomyTreeProps {
  taxonomy: GenericObject;
  index: number;
  actionMode: string | null;
  shouldExpandAll: boolean | null;
  deletedParentAndChildId: GenericObject | null;
  selectedTaxonomy: GenericObject | null;
  handleChangeShouldExpandAll(value: boolean | null): void;
  handleShowInfo(taxonomy: GenericObject | null): void;
}

export const TaxonomyTree = ({
  taxonomy,
  index,
  actionMode,
  shouldExpandAll,
  handleChangeShouldExpandAll,
  deletedParentAndChildId,
  handleShowInfo,
  selectedTaxonomy,
}: TaxonomyTreeProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleItem = () => {
    handleChangeShouldExpandAll(null);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (actionMode === ACTION_MODE.DEFAULT && selectedTaxonomy?.parent_category_id === taxonomy.id) {
      setIsOpen(true);
    }
  }, [actionMode, selectedTaxonomy, taxonomy]);

  useEffect(() => {
    if (shouldExpandAll === null) {
      return;
    }
    setIsOpen(shouldExpandAll);
  }, [shouldExpandAll]);

  return (
    <div>
      <TreeItem
        index={index}
        toggleItem={toggleItem}
        handleShowInfo={handleShowInfo}
        taxonomy={taxonomy}
        selectedTaxonomy={selectedTaxonomy}
        isOpen={isOpen}
      />
      {!!isOpen && (
        <TaxonomyNode
          handleChangeShouldExpandAll={handleChangeShouldExpandAll}
          shouldExpandAll={shouldExpandAll}
          deletedParentAndChildId={deletedParentAndChildId}
          actionMode={actionMode}
          taxonomy={taxonomy}
          handleShowInfo={handleShowInfo}
          selectedTaxonomy={selectedTaxonomy}
        />
      )}
    </div>
  );
};
